import React from "react";
import { Menu, Transition } from "@headlessui/react";
import { mdiArrowExpand, mdiSortVariant } from "@mdi/js";
import Icon from "@mdi/react";
import clsx from "clsx";

import Button from "components/Button";
import SubHeader from "components/SubHeader";
import { SEARCH_HEADER_ITEMS } from "constants/sub-header";
import useDeviceType from "hooks/useDeviceType";
import { IOption } from "models/Form";
import styles from "./style.module.scss";

interface IProps {
  viewType: string;
  onViewTypeChange: (value: string) => void;
  filter: Record<string, any>;
  setFilter: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  setIsHideDesktopFilter?: React.Dispatch<React.SetStateAction<boolean>>;
  filterOptions: IOption[];
  filterClass?: string;
  toggleTipModal?: VoidFunction;
}

export default function SubHeaderWithFilter({
  viewType,
  onViewTypeChange,
  filter,
  setFilter,
  filterOptions,
  setIsHideDesktopFilter,
  filterClass,
  toggleTipModal
}: Readonly<IProps>) {
  const { isDesktop } = useDeviceType();

  return (
    <div className={styles.trucksHeaderActions}>
      <SubHeader
        viewType={viewType}
        onViewTypeChange={onViewTypeChange}
        headerItems={SEARCH_HEADER_ITEMS}
      />

      {toggleTipModal && !isDesktop ? (
        <button type="button" className={styles.headerTipButton} onClick={toggleTipModal}>
          ProTip
        </button>
      ) : null}

      {isDesktop ? (
        <Button
          type="button"
          variant="outline"
          className="!p-1.5 !h-8 !rounded-md my-1"
          onClick={() => setIsHideDesktopFilter?.((prev) => !prev)}>
          <Icon path={mdiArrowExpand} className="!size-5" />
        </Button>
      ) : (
        <Menu as="div" className={styles.menuContainer}>
          <Menu.Button className="bg-transparent">
            <Icon path={mdiSortVariant} />
          </Menu.Button>

          <Transition
            as={React.Fragment}
            enter="transition ease-out duration-300"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95">
            <Menu.Items className={clsx(styles.itemWrapper, filterClass)}>
              {filterOptions.map((item) => (
                <Menu.Item key={item.id}>
                  <button
                    type="button"
                    onClick={() => {
                      if (filter.orderBy !== item.value) {
                        setFilter((prev) => ({ ...prev, orderBy: item.value }));
                      } else {
                        setFilter((prev) => ({ ...prev, orderBy: "-" + item.value }));
                      }
                    }}
                    className={clsx(
                      styles.item,
                      filter?.orderBy === item.value ? "text-primary" : "text-text"
                    )}>
                    {item.label}
                  </button>
                </Menu.Item>
              ))}
            </Menu.Items>
          </Transition>
        </Menu>
      )}
    </div>
  );
}
